import React from "react";
import ReactDOM from "react-dom/client";
import { Providers } from "./app/providers";
import { AppRouter } from "./app/router";
// Core design system (order matters: variables → reset → layout → components)
import "./styles/variables.css";
import "./styles/reset.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/buttons.css";
import "./styles/modals.css";
// Feature CSS extracted from App.css — loaded globally since many components
// relied on App.css being global. Will migrate to component-level imports later.
import "./components/Modals/Thermal/TrtModal.css";
import "./features/borefields/components/BorefieldDashboard.css";
import "./features/borefields/components/BorefieldDetail/CommonProperties.css";
import "./features/borefields/components/BorefieldDetail/PlanningTab.css";
import "./features/bores/components/BoreDashboard.css";
import "./features/bores/components/BoreItemSelectModal.css";
import "./features/bores/components/Bores.css";
import "./features/bores/components/DraggableCards.css";
import "./features/bores/components/JobsCard.css";
import "./features/circuits/components/CircuitsTab.css";
import "./components/maps/BoreMap.css";
import "./features/interference/components/InterferenceModal.css";
import "./features/reports/forms/shared/report-forms-shared.css";
import "./App.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </React.StrictMode>,
);
